import axios from 'axios';
import {logout} from '@/utils/logout';
import {getAccessToken} from '@/utils/access-token';
import {logger} from '@/utils/logger';

const api = axios.create();

api.interceptors.request.use((config) => {
  config.headers.Authorization = `Access ${getAccessToken()}`;

  return config;
});

api.interceptors.response.use(null, (error) => {
  logger.error('API request failed', {
    url: error.config && error.config.url,
    method: error.config && error.config.method,
    status: error.response && error.response.status,
    result: error.response && error.response.data && error.response.data.result,
    isNetworkError: !error.response,
    code: error.code,
    message: error.message,
  }, error);

  if (error.response && error.response.status === 403) {
    logout(true);
  }

  return Promise.reject(error);
});

export default api;
